import { useState } from "react";

import { API_APPRAISAL_V2 } from "../../../../config/Endpoints.js";
import { ApiError, postApi, putApi } from "../../../utils/api.ts";
import { accessToken } from "../../../utils/auth.ts";

type DraftResponse = { success?: boolean; message?: string; data?: { appraisalId?: number; status?: string } };

export function useCreateAppraisalDraft() {
  const [loading, setLoading] = useState(false);
  const saveDraft = async (payload: Record<string, unknown>, appraisalId?: number | null) => {
    setLoading(true);
    try {
      const { data } = appraisalId
        ? await putApi<DraftResponse>(`${API_APPRAISAL_V2}/${appraisalId}`, accessToken(), payload)
        : await postApi<DraftResponse>(API_APPRAISAL_V2, accessToken(), payload);
      return data;
    } catch (error) {
      throw error instanceof ApiError ? error : new Error("Failed to save appraisal draft.");
    } finally {
      setLoading(false);
    }
  };
  return { saveDraft, loading };
}
